import cn from 'classnames';

import { Text, Heading, Link } from '@sravni/react-design-system/lib/Typography';

import styles from './styles.module.scss';

type Props = {
  title: string;
  subTitle: string | JSX.Element;
  className?: string;
};

export const HeaderTitle = ({ title, subTitle, className }: Props) => (
  <div className={cn(styles.wrapper, className)}>
    <Heading className="h-color-D100" level={2}>
      {title}
    </Heading>
    <Text className="h-color-D60 h-pt-8" size={14}>
      {subTitle}
    </Text>
  </div>
);
